import type { Instruction } from './instructionTypes';
import { fallthroughInstructionKinds, ruleInstructionKinds } from './internal/instructionKinds';

export const OPERATORS = {
  in: 'in',
  endsWith: 'endsWith',
  startsWith: 'startsWith',
  matches: 'matches',
  contains: 'contains',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  before: 'before',
  after: 'after',
  segmentMatch: 'segmentMatch',
  semVerEqual: 'semVerEqual',
  semVerLessThan: 'semVerLessThan',
  semVerGreaterThan: 'semVerGreaterThan',
  applicationVersionSupported: 'applicationVersionSupported',
} as const;

export {
  allTargetInstructionKinds,
  fallthroughInstructionKinds,
  flagLevelInstructionKinds,
  flagVariationsInstructionKinds,
  prerequisiteInstructionKinds,
  replaceTargetsInstructionKind,
  ruleInstructionKinds,
  targetInstructionKinds,
} from './internal/instructionKinds';

/**
 * Instruction types
 */

export const FlagConfigInstructionTypes = {
  PREREQUISITES: 'prerequisites',
  TARGETS: 'targets',
  RULE: 'rule',
  FALLTHROUGH: 'fallthrough',
  TOGGLE_INSTRUCTIONS: 'toggleInstructions',
  TOGGLE_OFF_VARIATIONS: 'toggleOffVariations',
  ALL: 'all',
} as const;

export const FlagInstructionTypes = {
  VARIATIONS: 'variations',
  ALL: 'all',
} as const;

export const FALLTHROUGH_RULE_ID = 'fallthrough';

export const guardedReleasePhaseInstructions: Array<Instruction['kind']> = [
  fallthroughInstructionKinds.UPDATE_FALLTHROUGH_WITH_MEASURED_ROLLOUT_V2,
  fallthroughInstructionKinds.STOP_MEASURED_ROLLOUT_ON_FALLTHROUGH,
  ruleInstructionKinds.UPDATE_RULE_WITH_MEASURED_ROLLOUT_V2,
  ruleInstructionKinds.ADD_RULE_WITH_MEASURED_ROLLOUT_V2,
  ruleInstructionKinds.STOP_MEASURED_ROLLOUT_ON_RULE,
];
